<a [routerLink]="route" *ngIf="route.length > 0">
    <!-- <h4 class="mat-h4"> -->
        <mat-icon aria-label="Back">arrow_back</mat-icon> 
        back
    <!-- </h4> -->
</a>